import {consignee, consultation, placing, rollingStock, shipment, transportation} from 'assets';

const MENU_ITEMS = [
	{
		label: 'Организация перевозки грузов',
		icon: transportation,
		id: 'nav-item1',
		type: 1,
	},
	{
		label: 'Функции грузоотправителя и грузополучателя',
		icon: consignee,
		id: 'nav-item2',
		type: 2,
	},
	{
		label: 'Размещение и крепление грузов',
		icon: placing,
		id: 'nav-item3',
		type: 3,
	},
	{
		label: 'Предоставление вагонов и контейнеров',
		icon: rollingStock,
		id: 'nav-item4',
		type: 4,
	},
	{
		label: 'Организация погрузочно-разгрузочных работ',
		icon: shipment,
		id: 'nav-item5',
		type: 5,
	},
	{
		label: 'Консультирование по вопросам перевозки',
		icon: consultation,
		id: 'nav-item6',
		type: 6,
	},
];

export default MENU_ITEMS;
